import {
  AutoComplete,
  ReadOnly,
  useEntityPermission,
  useDataProvider,
} from '@ui-framework/index';
import { observer } from 'mobx-react';
import { useEffect, useState, forwardRef } from 'react';
import { useFormContext } from 'react-hook-form';

const Brands = forwardRef(
  ({ overwriteProps = {}, field, onChange, ...props }, ref) => {
    const nameKey = 'brandName';
    const valueKey = 'id';

    const provider =
      process.env.NODE_ENV === 'development' ? 'sxclServices' : 'default';
    const { get, getApiUrl } = useDataProvider(provider);
    const [defaultOptions, setDefaultOptions] = useState([]);

    const { setValue, getValues, watch } = useFormContext();

    const currentValue = getValues(field?.name);
    const lastIndustryValue = getValues(
      field?.dependencies?.industry || 'industryType',
    );
    const [lastIndustry, setLastIndustry] = useState(lastIndustryValue);

    const industry = watch(field?.dependencies?.industry || 'industryType');

    const getBrands = async ({ industryId, searchValue }) => {
      const searchParamm = searchValue ? `&brandName=$like:${searchValue}` : '';
      const result = await get(
        `${getApiUrl()}/sxcl/v1/brands?isActive=$eq:true&industry.id=$eq:${industryId}&limit=10&${searchParamm}`,
      );
      if (result.ok) {
        const resultsFound =
          result?.data?.data?.map(item => ({
            label: item[nameKey],
            value: item[valueKey],
          })) || [];
        return resultsFound;
      }
      return null;
    };

    const loadOptions = async (searchValue, callback) => {
      if (!searchValue) return [];
      const resultsData = await getBrands({
        industryId: industry?.value,
        searchValue,
      });
      if (resultsData) {
        return callback(resultsData);
      }
      return callback([]);
    };

    const { isHidden, isReadOnly } = useEntityPermission();

    if (isReadOnly(props?.permission, currentValue)) {
      return (
        <ReadOnly name={props?.name}>
          {currentValue?.label || currentValue?.[nameKey]}
        </ReadOnly>
      );
    }

    if (isHidden(props?.permission)) {
      return (
        <input
          type="hidden"
          name={props?.name}
          value={currentValue?.value || ''}
        />
      );
    }

    useEffect(() => {
      if (industry?.value !== lastIndustry?.value) {
        setValue(field.name, { label: '', value: '' });
        setDefaultOptions([]);
        setLastIndustry(industry);
      }
    }, [industry?.value]);

    return (
      <AutoComplete
        ref={ref}
        defaultOptions={defaultOptions}
        loadOptions={loadOptions}
        {...props}
        overwriteProps={overwriteProps}
        isClearable
      />
    );
  },
);

export default observer(Brands);
